import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
// `UsersTab` also renders on another company's profile (a read-only roster,
// `network/(pages)/(detail)/$companyId/users.tsx`) — it is not moved, only
// reused here for the caller's own company. See `UsersTab`'s doc comment.
import { UsersTab } from '@/app/(client)/network/-components/companyProfileTabs/users/UsersTab';
import { useSessionStore } from '@/store/sessionStore';

const searchSchema = z.object({
  page: z.number().int().min(1).optional(),
  limit: z.number().int().min(10).max(500).optional(),
  sort: z.string().optional(),
  filters: z.record(z.string(), z.array(z.string())).optional(),
});

export const Route = createFileRoute(
  '/(client)/company-settings/(pages)/users',
)({
  validateSearch: searchSchema,
  component: CompanySettingsUsersRoute,
});

function CompanySettingsUsersRoute() {
  const companyId = useSessionStore(s => s.user?.companyId);
  if (!companyId) return null;
  return <UsersTab companyId={companyId} isOwnCompany />;
}
